import About from "./containers/about";
import Contact from "./containers/contact";
import HomePage from "./containers/homepage";
import ListingDetail from "./containers/listing-detail";
import GlobalListingDetail from "./containers/global-listing-detail";
import MarketUpdate from "./containers/market-update";
import MyListings from "./containers/my-listings";
import GlobalListings from "./containers/global-listings";
import OurAdvantage from "./containers/our-advantage";
import QuickSearch from "./containers/quicksearch";
import PageNotFound from "./components/404";
import Press from "./containers/press";
import React from "react";
import { Route, IndexRoute } from "react-router";
import Search from "./containers/searchpage/";
import Solds from "./containers/solds";
import AppContainer from "./containers/app-container";
import Pledge from "./components/about-us/pledge";
import AccessibilityStatement from "./components/about-us/accessibility-statement";
import Terms from "./components/about-us/terms";
import DMCA from "./components/about-us/dmca";

export default (
  <Route path="/" component={AppContainer}>
    <IndexRoute component={HomePage} name="homepage" />
    <Route
      path="/our-advantage"
      component={OurAdvantage}
      name="our-advantage-page"
    />
    <Route
      path="/market-update"
      component={MarketUpdate}
      name="market-update"
    />
    <Route
      path="/listings/:listingType"
      component={MyListings}
      name="listings"
    />
    <Route
      path="/global-listings/:listingType"
      component={GlobalListings}
      name="global-listings"
    />
    <Route
      path="/globalestate/:id"
      component={GlobalListingDetail}
      name="listing-detail"
    />
    <Route path="/solds/:listingType" component={Solds} name="solds" />
    <Route path="/press" component={Press} name="press" />
    <Route path="/about" component={About} name="about" />
    <Route
      path="/about-us/fairhousingpledge"
      component={Pledge}
      name="Pledge"
    />
    <Route
      path="/about-us/accessibilitystatement"
      component={AccessibilityStatement}
      name="AccessibilityStatement"
    />
    <Route path="/about-us/termsandconditions" component={Terms} name="Terms" />
    <Route path="/about-us/dmca" component={DMCA} name="DMCA" />
    <Route path="/contact" component={Contact} name="contact" />
    <Route
      path="/quicksearch/:searchtype/:search"
      component={QuickSearch}
      name="quicksearch"
    />
    <Route
      path="/:region/quicksearch/:searchtype/:search"
      component={QuickSearch}
      name="quicksearch"
    />
    <Route path="/:region/:listingType" component={Search} name="search" />
    <Route
      path="/:region/sales/:id"
      component={ListingDetail}
      name="listing-detail"
    />
    <Route
      path="/:region/rentals/:id"
      component={ListingDetail}
      name="listing-detail"
    />
    <Route path="*" component={PageNotFound} name="404" />
  </Route>
);



// WEBPACK FOOTER //
// ./src/routes.js